import { render, staticRenderFns } from "./PlanejamentoClassificacao.vue?vue&type=template&id=8576ffd6&scoped=true"
import script from "./PlanejamentoClassificacao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoClassificacao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoClassificacao.vue?vue&type=style&index=0&id=8576ffd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576ffd6",
  null
  
)

export default component.exports